import { useEffect, useRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cx } from "./cx";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> {
  label?: ReactNode;
  description?: ReactNode;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
}

/** 多选框，支持半选。单个布尔开关且立即生效的场景用 Switch。 */
export function Checkbox({ label, description, indeterminate, onChange, className, ...rest }: CheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => { if (ref.current) ref.current.indeterminate = !!indeterminate; }, [indeterminate]);
  return (
    <label className={cx("ax-check", className)}>
      <input ref={ref} type="checkbox" onChange={(e) => onChange?.(e.target.checked)} {...rest} />
      <span className="ax-check-box" aria-hidden>
        <svg className="tick" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 6.5l2.5 2.5 4.5-5" /></svg>
        <svg className="dash" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round"><path d="M3 6h6" /></svg>
      </span>
      {label && (
        <span className="ax-check-text">
          <span>{label}</span>
          {description && <span className="ax-check-desc">{description}</span>}
        </span>
      )}
    </label>
  );
}
